<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="tabs-container">
        <ul class="nav nav-tabs" role="tablist">
          <li class="active"><a class="nav-link" data-toggle="tab"  href="#content" @click="activeComponent = 'contentTab'">Content</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#feed" @click="activeComponent = 'feedTab'">Builds</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#builds" @click="activeComponent = 'buildsTab'">Built Sites</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#links-built" @click="activeComponent = 'linksBuiltTab'" v-if="user.admin">Links Built</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#feed" @click="activeComponent = 'issuesTab'" v-if="!user.groups.length">Issues</a></li>
          <li><a class="nav-link" data-toggle="tab"  href="#feed" @click="activeComponent = 'issueSummaryTab'" v-if="!user.groups.length">Issue Summary</a></li>
          <li><a class="nav-link" data-toggle="tab" href="#data" @click="activeComponent = 'dataTab'" v-if="user.admin">Data</a></li>
          <li><a class="nav-link" data-toggle="tab" href="#link-tabs" @click="activeComponent = 'linkTagsTab'" v-if="user.admin">Link Tags</a></li>
          <li><a class="nav-link" data-toggle="tab" href="#dns-issues" @click="activeComponent = 'dnsIssuesTab'" v-if="user.admin">Dns Issues</a></li>
          <li><a class="nav-link" data-toggle="tab" href="#maintenance" @click="activeComponent = 'maintenanceTab'" v-if="user.admin">Maintenance</a></li>
          <li><a class="nav-link" data-toggle="tab" href="#instalinko" @click="activeComponent = 'instalinkoTab'" v-if="user.admin">Instalinko</a></li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane ibox-content active" role="tabpanel" id="feed">
            <div class="row">
              <component v-if="activeComponent" :is="activeComponent"></component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTab from './Overview/Data'
import FeedTab from './Overview/Feed'
import LinkTagsTab from './Overview/LinkTags'
import ContentTab from './Reports/NewContent/Report'
import IssuesTab from './Reports/Issues'
import LinksBuiltTab from './Reports/LinksBuilt'
import IssueSummaryTab from './Reports/IssueSummary'
import DnsIssuesTab from './Reports/DnsIssues'
import MaintenanceTab from './Reports/Maintenance'
import InstalinkoTab from './Reports/Instalinko'
import buildsTab from './Reports/Builds'

import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      'pbn': 'sucks',
      activeComponent: 'contentTab'
    }
  },
  mounted () {
    document.title = 'Reports :: PBN360 by Aphex Media'
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser'
    })
  },
  components: {
    dataTab: DataTab,
    feedTab: FeedTab,
    linkTagsTab: LinkTagsTab,
    contentTab: ContentTab,
    issuesTab: IssuesTab,
    linksBuiltTab: LinksBuiltTab,
    IssueSummaryTab: IssueSummaryTab,
    DnsIssuesTab: DnsIssuesTab,
    maintenanceTab: MaintenanceTab,
    instalinkoTab: InstalinkoTab,
    buildsTab: buildsTab
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Overview.vue